// Service worker registration with robust update handling

const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const onLoad = () => {
      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          // Listen for updates
          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                const isUpdate = navigator.serviceWorker.controller;
                if (isUpdate) {
                  // New content available
                  config?.onUpdate?.(registration);
                } else {
                  // Content cached for offline use
                  config?.onSuccess?.(registration);
                }
              }
            };
          };

          // Periodically check for updates
          setInterval(() => {
            registration.update().catch(() => {});
          }, 60 * 60 * 1000);
        })
        .catch(() => {
          // Silent fail to avoid breaking app start
        });
    };

    if (document.readyState === 'complete') onLoad();
    else window.addEventListener('load', onLoad);
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          registration.unregister();
        });
      })
      .catch(() => {});
  }

  if ('caches' in window) {
    caches.keys()
      .then((cacheNames) => Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName))))
      .catch(() => {});
  }
}

